// libraries
import React from "react";

// components
import Content from "../components/Register/Content/Content";

const ResetPassword = () => {
  return <Content initailIndex={5} />;
};

export default ResetPassword;
